import {fetchApi} from "../fetch";
import {API_URL} from "../../constants/axios";

export const getScreen = async () => {
    const res = await fetchApi.get(API_URL.SIMPLE_SCREEN)
    return res.data;
}

export const updateScreen = async (isActive, logoUrl, entrypointId, isNaver, isFacebook, isApple, isGoogle,
                                   showNonLoginPurchase, showNonLoginSearch, eventButtonName, bubbleName) => {
    const res = await fetchApi.post(API_URL.SIMPLE_SCREEN, {
        isActive: isActive,
        logoUrl: logoUrl,
        entrypointId: entrypointId,
        isNaver: isNaver,
        isFacebook: isFacebook,
        isApple: isApple,
        isGoogle: isGoogle,
        showNonLoginPurchase: showNonLoginPurchase,
        showNonLoginSearch: showNonLoginSearch,
        eventButtonName: eventButtonName,
        bubbleName: bubbleName?.length === 0 ? null : bubbleName,
    })
    return res.data;
}